import { Component, Input, OnInit } from '@angular/core';
import { AccountTypeContent, getAccountTypeContentByTotalNetEquity } from './account-type-content';
import { AdvisorEntity } from '@toro/common/shared/entities/advisor.entity';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { ILoggedHomeAppState } from '../../interfaces/logged-home-app-state.interface';
import { skip } from 'rxjs/operators';
import { AdvisorAction } from '@toro/common/shared/state-management/advisor/advisor.action';
@Component({
  selector: 'account-type',
  templateUrl: './account-type.component.html',
  styleUrls: ['./account-type.component.scss']
})
export class AccountTypeComponent implements OnInit {
  @Input()
  public totalNetEquity: number = 0;

  public accountTypeContent: AccountTypeContent;
  public percentualBarLoader = 0;
  public barLegend = '';
  public textMinValueTransfer = ''
  public disposableSubscriptions: Subscription[] = [];
  public advisor: AdvisorEntity;

  constructor(private store: Store<ILoggedHomeAppState>) {
  }


  public ngOnInit(): void {
    this.disposableSubscriptions.push(
      this.store
        .select((state) => state.advisor.customerAdvisor)
        .pipe(skip(1))
        .subscribe((data) => {
          this.advisor = data;
          this.setup();
        }));

    this.setup();

    this.store.dispatch({ type: AdvisorAction.getAdvisor });
  }

  public setup() {
    this.accountTypeContent = getAccountTypeContentByTotalNetEquity(this.totalNetEquity, !!this.advisor);
    this.percentualBarLoader = (this.accountTypeContent.currentAccountType === 'REGISTRATION')
      ? 3 : this.totalNetEquity / this.accountTypeContent.nextAccountTypeMinValue * 100;

    if (this.accountTypeContent.currentAccountType === 'REGISTRATION') {
      this.barLegend = 'Conta Digital a partir da primeira transferência';
      this.textMinValueTransfer = 'Conta Digital a partir da primeira transferência de recursos';
    }
    else if (this.accountTypeContent.currentAccountType === 'EXCLUSIVE') {
      this.barLegend = '';
      this.textMinValueTransfer = '';
    }
    else {
      this.barLegend = "Faltam " + (this.accountTypeContent.nextAccountTypeMinValue - this.totalNetEquity).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
        + " para ativar a " + this.accountTypeContent.nextAccountLabel;
      this.textMinValueTransfer = "Transferindo a partir de " + this.accountTypeContent.nextAccountTypeMinValue.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    }
  }
}
